.box {
  max-width: 640px;
  margin: 0 auto;
  padding: 96px var(--gutter) 32px;
  text-align: center;
}

.title {
  margin: 0;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 54px;
  line-height: 1;
}

.text {
  margin: 16px 0 32px;
  font-size: 16px;
  line-height: 1.6;
  color: var(--text-secondary);
}

.button {
  display: inline-flex;
  align-items: center;
  height: 52px;
  padding: 0 40px;
  border-radius: var(--radius-pill);
  background: var(--primary);
  color: #ffffff;
  font-size: 15px;
  font-weight: 500;
}

.button:hover {
  color: #ffffff;
  background: var(--primary-hover);
}
